import styled from "styled-components";

import { transition } from "@ui/helpers";
import { defaultOptions } from "@ui/style";
import { Text } from "@ui/Atoms/Text";

export const Link = styled(Text).attrs({
  $allUnset: true,
})`
  color: ${({ $color, theme }) =>
    $color ? theme.palette[$color] : "currentColor"};
  transition: ${transition("color")};
  cursor: pointer;

  &:hover {
    color: currentColor;

    ${props => props.theme.breakpointsV2.smallTablet} {
      color: ${defaultOptions.linkHoverColor};
    }
  }
`;
